import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import {
	searchMember,
	onlineCollection,
	addMomoPayment,
	onlineAccountInfo,
} from "../../../api/apiServices";
import generateTransactionId from "../../../services/generateTransactionId";
import { PaymentSuccess } from "./PaymentSuccess";
import getServiceProvider from "../../../services/getServiceProvider";

const languageId = `${process.env.REACT_APP_LANGUAGE_ID}`;
const countryCode = `${process.env.REACT_APP_COUNTRY_CODE}`;
const transCurrencyIso = `${process.env.REACT_APP_TRANS_CURRENCY_ISO}`;
const paymentWithDifferentNumber = [
	{
		id: 1,
		label: "NO",
		value: "0",
	},
	{
		id: 2,
		label: "YES",
		value: "1",
	},
];

const AdmissionFeePayment = (mobile) => {
	const mobileNumber = decodeURI(mobile.mobile[0]);

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/";

	let currentDate = new Date();
	let paymtYear = String(currentDate.getFullYear());

	const [findApplicant, setFindApplicant] = useState([]);
	const [isPayWithDifferentNumber, setIsPayWithDifferentNumber] =
		useState(false);

	const [differentNumber, setDifferentNumber] = useState("");

	const [other_number, setOtherNumber] = useState("");
	const [otherPhoneNumberFullname, setOtherPhoneNumberFullname] =
		useState("");

	const [isPaymentSuccessful, setIsPaymentSuccessful] = useState(false);
	const [successfulPayment, setSuccessfulPayment] = useState({
		title: "",
		message: "",
		emailCheck: "",
		thanks: "",
	});

	const [payment_year, setPaymentYear] = useState(paymtYear);
	const [amount, setAmount] = useState(1000);
	const [payPartnerServiceId, setPayPartnerServiceId] = useState("");
	const [transaction_id, setTransactionId] = useState("");

	useEffect(() => {
		const searchData = {
			pf_number: null,
			mobile_number: mobileNumber ? mobileNumber : null,
			first_name: null,
			last_name: null,
		};
		const getMemberInfo = async () => {
			await searchMember(searchData).then(async (response) => {
				setFindApplicant(response);
				await generateTransactionId().then((result) => {
					setTransactionId(result);
				});
			});
		};
		getMemberInfo();
	}, [mobileNumber]);

	let fullname = "";
	let mobile_number = "";
	for (var i = 0; i < findApplicant?.length; i++) {
		fullname =
			findApplicant[i].first_name +
			" " +
			findApplicant[i].middle_name +
			" " +
			findApplicant[i].last_name;
		mobile_number = findApplicant[i].mobile_number;
	}

	const handlePayWithDifferentNumber = (e) => {
		const value = e.target.value;

		if (value === "1") {
			setIsPayWithDifferentNumber(true);
			setDifferentNumber(value);
		} else {
			setIsPayWithDifferentNumber(false);
			setDifferentNumber(value);
			getServiceProvider(mobileNumber).then((result) => {
				setPayPartnerServiceId(result);
			});
		}
	};

	const handleMobileNumberInput = (value, countryObj, e, formattedValue) => {
		let mobileNumber = value.replaceAll(" ", "");
		if (mobileNumber.substring(4, 0) === "2330") {
			mobileNumber = mobileNumber.replace("0", "");
			setOtherNumber(mobileNumber);
		}
	};


	const handleAccountInfo = async (e) => {
		const value = e.target.value.replaceAll(" ", "");
		let mobileNumber = "";
		if (value === "") {
			toast.error("Please enter your mobile number", {
				duration: 5000,
				className: "toast-message",
			});
			return false;
		} else if (value === "+233") {
			toast.error(
				"The mobile number is not valid. Please provide a valid mobile number to continue",
				{
					duration: 5000,
					className: "toast-message",
				}
			);
			return false;
		}

		if (value.substring(5, 0) === "+2330") {
			mobileNumber = value.replace("0", "");
		} else {
			mobileNumber = value;
		}
		mobileNumber = mobileNumber.replace("+", "");

		let serviceProvider = "";
		await getServiceProvider(mobileNumber).then((result) => {
			serviceProvider = result;
			setPayPartnerServiceId(result);
		});
		const infoData = {
			CustomerAcctNo: mobileNumber,
			PayPartnerServiceId: serviceProvider,
			LanguageId: languageId,
			CountryCode: countryCode,
		};
		getMemberInfoMutation.mutate(infoData);
	};

	const getMemberInfoMutation = useMutation(onlineAccountInfo, {
		onSuccess: async (res) => {
			if (res.data.Status === false && res.status === 201) {
				toast.error(res.data.Message, {
					duration: 5000,
					className: "toast-message",
				});
				return false;
			}
			if (res.data.Status === false && res.status === 200) {
				toast.error(res.data.Message, {
					duration: 5000,
					className: "toast-message",
				});
				return false;
			}
			if (res.data.Status === true) {
				setOtherPhoneNumberFullname(res.data.AccountName);
				return true;
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			return false;
		},
	});

	const handleOnlinePayment = async (e) => {
		e.preventDefault();

        if (!differentNumber) {
            toast.error("Please select if you want to pay with a different number", {
                duration: 5000,
                className: "toast-message",
            });
            return false
        }
		const momoPaymentData = {
			PayPartnerServiceId: payPartnerServiceId,
			Amount: amount,
			AccountNoOrCardNoOrMSISDN: !isPayWithDifferentNumber
				? mobile_number
				: other_number,
			AccountName: !isPayWithDifferentNumber
				? fullname.toLocaleUpperCase()
				: otherPhoneNumberFullname.toLocaleUpperCase(),
			TransactionId: transaction_id,
			LanguageId: languageId,
			Narration: "PF Payment",
			TransCurrencyIso: transCurrencyIso,
			ExpiryDateMonth: 0,
			ExpiryDateYear: 0,
			Cvv: 0,
		};
		onlineCollectionMutation.mutate(momoPaymentData);
	};

	const onlineCollectionMutation = useMutation(onlineCollection, {
		onSuccess: async (res) => {
			if (res.data.Status === true) {
				const momoPaymentData = {
					PayPartnerServiceId: payPartnerServiceId,
					amount: parseFloat(amount).toFixed(2),
					mobile_number: mobile_number,
					fullname: fullname.toLocaleUpperCase(),
					payment_year: payment_year,
					payment_type: "MP",
					payment_mode: "M",
					pf_number: "",
					transaction_id: transaction_id,
				};
				addMomoMutation.mutate(momoPaymentData);
            } else {
                setSuccessfulPayment({
					title: "Admission Fee Payment",
					message: res.data.message,
					emailCheck:
						"Please check the balance in your momo wallet and try again",
					thanks: "Thank you",
				});
				// toast.error(res.data.message, {
				// 	duration: 5000,
				// 	className: "toast-message",
				// });
				setIsPayWithDifferentNumber(false);
				// navigate(from, { replace: true });
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsPayWithDifferentNumber(false);
			navigate(from, { replace: true });
		},
	});

	const addMomoMutation = useMutation(addMomoPayment, {
		onSuccess: async (res) => {
			if (res.success === true) {
				setSuccessfulPayment({
					title: "Admission Fee Payment",
					message: res.message,
					emailCheck:
						"Please check your email for further instructions",
					thanks: "Thank you",
				});
				setIsPaymentSuccessful(true);
				setIsPayWithDifferentNumber(false);
				setPaymentYear("");
				setAmount("");
				// navigate(from, { replace: true });
			} else {
				// toast.success(res.message, {
				// 	duration: 5000,
				// 	className: "toast-message",
				// });
                setSuccessfulPayment({
					title: "Admission Fee Payment",
					message: res.message,
					emailCheck:
						"Please check your email for further instructions",
					thanks: "Thank you",
				});
				setIsPayWithDifferentNumber(false);
				setPaymentYear("");
				setAmount("");
				// navigate(from, { replace: true });
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsPayWithDifferentNumber(false);
			setPaymentYear("");
			setAmount("");
			navigate(from, { replace: true });
		},
	});

	const handleCancel = () => {
		navigate("/");
	};

	const paymentForm = (
		<form onSubmit={handleOnlinePayment}>
			<div className="form-group row">
				<fieldset className="col-sm-6">
					<label
						htmlFor="fullname"
						className="col-sm-4 col-form-label"
					>
						Full Name<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							name="fullname"
							id="fullname"
							placeholder="FullName"
							style={{
								height: "40px",
								fontWeight: "bold",
								textTransform: "uppercase",
							}}
							required
							disabled
							autoComplete="off"
							value={fullname}
							className="form-control"
						/>
					</div>
					<label htmlFor="mobile_number" className="col-sm-4">
						Mobile Number<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<PhoneInput
							id="mobile_number"
							inputStyle={{
								paddingTop: 16,
								paddingRight: 14,
								paddingBottom: 15,
								paddingLeft: 58,
								fontSize: 16,
								width: "100%",
								zIndex: 1,
								height: 40,
								backgroundColor: "#F3F6F9",
							}}
							country={"gh"}
							countryCodeEditable={false}
							enableSearch={true}
							value={mobile_number}
							disabled
						/>
					</div>
					<label htmlFor="amount" className="col-sm-4 col-form-label">
						Amount<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="number"
							name="amount"
							id="amount"
							style={{
								height: "40px",
								textTransform: "uppercase",
								fontWeight: "bold",
							}}
							placeholder="Amount"
							required
							disabled
							value={amount}
							onChange={(e) => setAmount(e.target.value)}
							className="form-control"
						/>
                        <span style={{
                            fontSize: "16px",
                            color: "var(--brown)",
                        }}>
							An additional fee may apply to this payment amount
						</span>
					</div>
					<label
						htmlFor="different_number"
						className="col-sm-4 col-form-label"
					>
						Pay With Another Number?
						<span>&nbsp;&nbsp;*</span>
					</label>
					{paymentWithDifferentNumber.map((item, index) => (
						<div className="col-sm-4" key={index}>
							<label htmlFor="different_number">
								<input
									type="checkbox"
									id="different_number"
									name="different_number"
									checked={differentNumber === item.value}
									value={item.value}
									onChange={handlePayWithDifferentNumber}
								/>
							</label>
							{item.label}
						</div>
					))}

					{isPayWithDifferentNumber && (
						<>
							<label
								htmlFor="another_phone_number"
								className="col-sm-4"
							>
								Enter Phone Number<span>&nbsp;&nbsp;*</span>
							</label>
							<div className="col-sm-8">
								<PhoneInput
									id="another_phone_number"
									inputStyle={{
										paddingTop: 16,
										paddingRight: 14,
										paddingBottom: 15,
										paddingLeft: 58,
										fontSize: 16,
										width: "100%",
										zIndex: 1,
										height: 40,
										backgroundColor: "#F3F6F9",
									}}
									country={"gh"}
									countryCodeEditable={false}
									enableSearch={true}
									value={other_number}
									inputProps={{
										name: "other_number",
										required: true,
										autoFocus: false,
									}}
									onChange={(
										value,
										countryObj,
										e,
										formattedValue
									) =>
										handleMobileNumberInput(
											value,
											countryObj,
											e,
											formattedValue
										)
									}
									onBlur={handleAccountInfo}
								/>
							</div>
							<label
								htmlFor="otherPhoneFullname"
								className="col-sm-4 col-form-label"
							>
								Full Name (From Telco)<span>&nbsp;&nbsp;*</span>
							</label>
							<div className="col-sm-8">
								<input
									type="text"
									name="otherPhoneFullname"
									id="otherPhoneFullname"
									style={{
										height: "40px",
										fontWeight: "bold",
										textTransform: "uppercase",
									}}
									required
									disabled
									autoComplete="off"
									value={otherPhoneNumberFullname}
									onChange={(e) =>
										setOtherPhoneNumberFullname(
											e.target.value
										)
									}
									className="form-control"
								/>
							</div>
						</>
					)}
				</fieldset>
			</div>
			<div className="panel-footer">
				<div className="row">
					<div className="col-sm-1">
						<button
							type="submit"
							className="btn btn-success btn-block"
						>
							Submit
						</button>
					</div>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<div className="col-sm-1">
						<button
							type="button"
							onClick={handleCancel}
							className="btn btn-danger btn-block"
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		</form>
	);

	return (
		<>
			<Toaster toastOptions={{ position: "top-center" }} />
			<section className="content-header">
				<h1>
					<i className="fas fa-bank"></i> Admission Fee Payments
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>Mandatory Payment</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								{isPaymentSuccessful ? (
									<PaymentSuccess
										success={successfulPayment}
									/>
								) : (
									paymentForm
								)}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default AdmissionFeePayment;
